package com.mgacreative.hotelru.feature.hotel.ui.auth

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mgacreative.hotelru.shared.ui.designsystem.components.HFTextField
import com.mgacreative.hotelru.shared.ui.designsystem.components.HFLoadingState
import com.mgacreative.hotelru.shared.ui.designsystem.components.LanguageSelectorRow
import com.mgacreative.hotelru.shared.ui.designsystem.i18n.l10n
import com.mgacreative.hotelru.feature.hotel.ui.components.AppLogo

@Composable
fun RegisterScreen(viewModel: AuthViewModel) {
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }
    var hotelName by remember { mutableStateOf("") }
    
    val isLoading by viewModel.isLoading.collectAsState()
    val error by viewModel.errorMessage.collectAsState()

    if (isLoading) {
        HFLoadingState()
        return
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .background(
                Brush.verticalGradient(
                    colors = listOf(
                        Color(0xFF0F172A),
                        Color(0xFF1E293B)
                    )
                )
            ),
        contentAlignment = Alignment.Center
    ) {
        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            modifier = Modifier.padding(24.dp).widthIn(max = 440.dp).fillMaxWidth()
        ) {
            LanguageSelectorRow(modifier = Modifier.padding(bottom = 16.dp))

            AppLogo(modifier = Modifier.size(100.dp).padding(bottom = 16.dp))
            
            Card(
                shape = RoundedCornerShape(24.dp),
                colors = CardDefaults.cardColors(
                    containerColor = Color(0xFF1E293B)
                ),
                elevation = CardDefaults.cardElevation(defaultElevation = 12.dp),
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(
                    modifier = Modifier.padding(28.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {
                    Text(
                        text = l10n("Yeni Kayıt"),
                        fontSize = 24.sp,
                        fontWeight = FontWeight.Bold,
                        color = Color.White
                    )
                    Spacer(Modifier.height(8.dp))
                    Text(
                        text = l10n("Kendi otel sisteminizi oluşturun"),
                        fontSize = 14.sp,
                        color = Color(0xFF94A3B8)
                    )
                    Spacer(Modifier.height(28.dp))
                    
                    HFTextField(
                        value = hotelName,
                        onValueChange = { hotelName = it },
                        label = l10n("Otel Adı"),
                        isError = error != null
                    )
                    Spacer(Modifier.height(16.dp))
                    HFTextField(
                        value = email,
                        onValueChange = { email = it },
                        label = l10n("E-posta"),
                        isError = error != null
                    )
                    Spacer(Modifier.height(16.dp))
                    HFTextField(
                        value = password,
                        onValueChange = { password = it },
                        label = l10n("Şifre"),
                        isError = error != null,
                        visualTransformation = androidx.compose.ui.text.input.PasswordVisualTransformation()
                    )
                    
                    if (error != null) {
                        Spacer(Modifier.height(8.dp))
                        Text(
                            text = error!!, 
                            color = MaterialTheme.colorScheme.error,
                            fontSize = 12.sp,
                            modifier = Modifier.fillMaxWidth()
                        )
                    }

                    Spacer(Modifier.height(28.dp))
                    
                    Button(
                        onClick = { viewModel.register(email, password, hotelName) },
                        modifier = Modifier.fillMaxWidth().height(52.dp),
                        shape = RoundedCornerShape(14.dp),
                        colors = ButtonDefaults.buttonColors(
                            containerColor = Color(0xFF2563EB)
                        )
                    ) {
                        Text(l10n("Kayıt Ol"), fontSize = 16.sp, fontWeight = FontWeight.SemiBold, color = Color.White)
                    }
                    
                    Spacer(Modifier.height(20.dp))
                    
                    TextButton(onClick = { viewModel.authNavigator.navigateTo(AuthScreenType.LOGIN) }) {
                        Text(l10n("Zaten hesabınız var mı? Giriş Yap"), color = Color(0xFF60A5FA), fontWeight = FontWeight.Medium)
                    }
                }
            }
        }
    }
}
